import { Box, chakra, Container, Image, Link, Stack, Text, useColorModeValue, VisuallyHidden } from '@chakra-ui/react';
import { FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';
import { ReactNode } from 'react';
import NextLink from 'next/link';

const SocialButton = ({ children, label, href }) => {
  return (
    <chakra.button
      bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.100')}
      rounded={'full'}
      w={8}
      h={8}
      cursor={'pointer'}
      as={'a'}
      href={href}
      display={'inline-flex'}
      alignItems={'center'}
      justifyContent={'center'}
      transition={'background 0.3s ease'}
      target={'_blank'}
      _hover={{
        bg: useColorModeValue('blackAlpha.200', 'whiteAlpha.200'),
      }}
    >
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
    </chakra.button>
  );
};

export default function Footer() {
  return (
    <Box bg={useColorModeValue('white', 'gray.900')} color={useColorModeValue('gray.700', 'gray.200')}>
      <Container as={Stack} maxW={'6xl'} py={4} spacing={4} justify={'center'} align={'center'}>
        <Image src={'/images/common/logo.png'} w={'200px'} />
        <Stack direction={{ sm: 'column', md: 'row' }} spacing={6} color={'gray.600'} fontSize={'sm'}>
          <NextLink href={'https://www.dxr.co.jp/'} passHref>
            <Link target={'_blank'}>運営企業</Link>
          </NextLink>
          <NextLink
            href={'https://ai-copywriter.notion.site/ai-copywriter/Catchy-AI-writer-8fa43ce884f7474799765728675d7025'}
            passHref
          >
            <Link target={'_blank'}>ヘルプサイト</Link>
          </NextLink>
          <NextLink href={'/terms'} passHref>
            <Link target={'_blank'}>利用規約</Link>
          </NextLink>
          <NextLink href={'/privacy'} passHref>
            <Link target={'_blank'}>プライバシーポリシー</Link>
          </NextLink>
          <NextLink href={'/tos'} passHref>
            <Link target={'_blank'}>特商法に基づく表記</Link>
          </NextLink>
          <NextLink href={'/contents-policy'} passHref>
            <Link target={'_blank'}>コンテンツポリシー</Link>
          </NextLink>
          <NextLink href={'https://forms.gle/oZTrxU5i32bHydRZ8'} passHref>
            <Link target={'_blank'}>お問い合わせ</Link>
          </NextLink>
        </Stack>
      </Container>

      <Box borderTopWidth={1} borderStyle={'solid'} borderColor={useColorModeValue('gray.200', 'gray.700')}>
        <Container
          as={Stack}
          maxW={'6xl'}
          py={4}
          direction={{ base: 'column', md: 'row' }}
          spacing={4}
          justify={{ base: 'center', md: 'space-between' }}
          align={{ base: 'center', md: 'center' }}
        >
          <Text color={'gray.600'}>© 2022 Digital Recipe, inc. All rights reserved.</Text>
          <Stack direction={'row'} spacing={6}>
            <SocialButton label={'Twitter'} href={'https://twitter.com/ai_copywriter'}>
              <FaTwitter />
            </SocialButton>
            <SocialButton label={'YouTube'} href={'https://www.youtube.com/channel/UCUR9kWnfE9fntw_CDUSuCJg/featured'}>
              <FaYoutube />
            </SocialButton>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
}
